import { render, staticRenderFns } from "./PharmacistList.vue?vue&type=template&id=c4c61184&scoped=true&"
import script from "./PharmacistList.vue?vue&type=script&lang=ts&"
export * from "./PharmacistList.vue?vue&type=script&lang=ts&"
import style0 from "./PharmacistList.vue?vue&type=style&index=0&id=c4c61184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c61184",
  null
  
)

export default component.exports